import BaseApi from './base';

class ClausulasConfirmacionProcesosApi extends BaseApi {
  constructor() {
    super('clausulas_confirmacion_procesos');
  }
}

export default new ClausulasConfirmacionProcesosApi();
